import React from 'react'
import { Button, Row, Col, } from 'reactstrap'
import { Link, } from 'react-router-dom'

export default function AssessSubtestInfoBlock({
  status, 
  correct, 
  possible, 
  skillReportLink, 
  itemReportLink, 
  isStudent }) {

  const correctDisplay = isStudent ? `${correct}/${possible}` : `${Math.round(correct/possible*100)}%`

  return (
    <div>
      {status === 'start' &&
        <div className='subtest-info'>
          { !!possible &&
            <p className='num-questions-correct'>
              {`${correctDisplay} Correct`}
            </p>
          }
          <Row className='view-reports'>
            <Col xs='12' sm='6' lg='12' xl='6'>
              <Link className='skill-report' to={skillReportLink}>
                <Button block>Skill Report</Button>
              </Link>
            </Col>
            <Col xs='12' sm='6' lg='12' xl='6'>
              <Link className='item-report' to={itemReportLink}>
                <Button block>Item Report</Button>
              </Link>
            </Col>
          </Row>
        </div>
      }
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessSubtestInfoBlock.js